import { createContext, useState, useContext, useEffect } from "react";
import {setAuthToken} from "../api/api";
import {decodeToken} from "../utils/token";

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [user, setUser] = useState(localStorage.getItem("user"));

    const login = (token, userInfo) => {
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(userInfo)); // ✅ stocke user
        setToken(token);
        setUser(userInfo);
        setAuthToken(token)
    };

    useEffect(() => {
        if (token) {
            const userId = decodeToken(token);
            if (!userId) {
                // Token invalide ou expiré
                logout();
            } else {
                setAuthToken(token); // remet le token dans axios
                setUser({ id: userId }); // optionnel : récupérer plus d'infos
            }
        }
    }, [token]);

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setToken(null);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ token, user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);